import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { mustSee } from "@/mocks/guagua";

export default function MustSeeSection() {
  return (
    <section id="mustsee" className="w-full scroll-mt-20 border-b border-background-200 bg-secondary-100/50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="精选列表"
            title="网爆吃瓜必看清单"
            description="读的人最多、被收藏最多的合集集合。作为入门索引，适合第一次来先把这几个补上。"
          />
          <Link
            to="/collections"
            className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-full border border-secondary-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-secondary-800 transition-colors hover:bg-background-100 md:self-auto"
          >
            想看更多
            <i className="ri-arrow-right-line leading-none" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {mustSee.map((item, index) => (
            <Link
              key={item.id}
              to={`/collection/${item.id}`}
              className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-secondary-400"
            >
              <div className="flex items-center justify-between">
                <span className="font-heading text-3xl font-black text-secondary-300 transition-colors group-hover:text-secondary-500">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="rounded-full bg-background-100 px-2.5 py-1 text-xs text-foreground-600">
                  {item.categoryName}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
              <div className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1 text-primary-600">
                  <i className="ri-bookmark-3-line leading-none" aria-hidden="true"></i>
                  {item.heat} 收藏
                </span>
                <span>{item.readTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}